import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
}

const initialState: ResponsiveState = {
  isMobile: false,
  isTablet: false,
  isDesktop: true,
  screenWidth: window.innerWidth,
};

const responsiveSlice = createSlice({
  name: 'responsive',
  initialState,
  reducers: {
    setScreenSize: (state, action: PayloadAction<{ width: number; height: number }>) => {
      const { width } = action.payload;

      return {
        ...state,
        screenWidth: width,
        isMobile: width <= 900,
        isTablet: width > 900 && width <= 1200,
        isDesktop: width > 1200,
      };
    },
    setMobile: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isMobile: action.payload,
      };
    },
  },
});

export const { setScreenSize, setMobile } = responsiveSlice.actions;
export default responsiveSlice.reducer;
